import React from "react";
import { financeAssets, animalAssets } from "../../../services/constant";
import '../../../pages/animal/main.css';

export default function SiderBar({ sideState, setSideState }) {

    const handleClick = () => {
        sideState === 1 ? setSideState(0) : setSideState(1);
    }
    return (
        <div className="sidebar ">
            <div className="flex flex-row gap-[8px] pt-[27px] pl-[23px]">
                <img src={financeAssets.ic_sidebar} className="w-[37px] h-[37px]" />
                <h2 className="font-18-900 font-color self-center">GESTÃO FINANCEIRA</h2>
            </div>
            <div className="animal_data flex flex-col gap-[1.5rem] mt-[1.5rem]">
                {
                    sideState === 1 ?
                        (<><button className="data_add font-14-500 " onClick={() => handleClick()} >DASHBOARD <img src={animalAssets.ic_arrow_right} className="data_add_icon" alt="" /></button><div className=""><button className="data_title font-14-400 " onClick={() => handleClick()}>Transações</button></div></>)
                        :
                        (<><div className=""><button className="data_title font-14-400 font-left " onClick={() => handleClick()} >DASHBOARD </button></div><button className="data_add font-14-500 " onClick={() => handleClick()}>Transações <img src={animalAssets.ic_arrow_right} className="data_add_icon" alt="" /></button></>)
                }
                <div className="data_info font-14-400">Detalhes da Conta</div>
            </div>
            <div className="sidebar_bottom "><img src={animalAssets.sidebar_footer} alt="" className="justify-self-center mx-auto" /></div>
        </div>
    );
}